function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { InternalServerError } from "server/extensions/error-extensions";
import { trackBigBrainEventOnServer } from "server/services/bigbrain-tracking-service/bigbrain-tracking-service";
import { CAREER_POSITIONS_RETRIEVE_FROM_COMEET } from "constants/bigbrain-event-types";
import { LAST_ACCOUNT_SLUG } from "constants/cookies";
import * as Sentry from "@sentry/nextjs";
const POSITION_TYPE_CATEGORY_NAME = "Publish Position";
const POSITION_TYPE_INTERNAL_VALUE = "Internal Career Site";
const POSITION_TYPE_INTERNAL = "internal";
const POSITION_TYPE_ALL = "all"; // Show both internal and external positions
const POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE = "Both";
const COMEET_COMPANY_UID = "41.00B"; // Used also in client side - fix
const COMEET_END_POINT = `https://www.comeet.co/careers-api/2.0/company/${COMEET_COMPANY_UID}/positions`;
const getDataFromComeet = function() {
    var _ref = _async_to_generator(function*(positionId = null) {
        const { get } = require("../../../../../secrets-service");
        const { api_token: COMEET_TOKEN } = yield get("comeet");
        const COMEET_PARAMS = `?token=${COMEET_TOKEN}&details=true`;
        const url = positionId ? `${COMEET_END_POINT}/${positionId}${COMEET_PARAMS}` : `${COMEET_END_POINT}${COMEET_PARAMS}`;
        const options = {
            insecureHTTPParser: true
        };
        yield trackBigBrainEventOnServer(CAREER_POSITIONS_RETRIEVE_FROM_COMEET, {
            kind: positionId ? "single_position" : "all_positions",
            info1: positionId
        });
        const response = yield fetch(url, options);
        return yield response.json();
    });
    return function getDataFromComeet() {
        return _ref.apply(this, arguments);
    };
}();
const getPublishCategoryValue = (position)=>{
    const publishCategory = position === null || position === void 0 ? void 0 : position.categories.find((category)=>category.name === POSITION_TYPE_CATEGORY_NAME);
    return publishCategory && publishCategory.value;
};
const isPositionRelevantToType = (position, positionsType, isMondayEmployee = false)=>{
    const publishCategoryValue = getPublishCategoryValue(position);
    return publishedPositionFitsType(publishCategoryValue, positionsType, isMondayEmployee);
};
const publishedPositionFitsType = (publishCategoryValue, requestedPositionsType, isMondayEmployee = false)=>{
    // If requesting all positions, show everything (both internal and external)
    if (requestedPositionsType === POSITION_TYPE_ALL) {
        return true;
    }
    if (requestedPositionsType === POSITION_TYPE_INTERNAL && publishCategoryValue) {
        return publishCategoryValue === POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE || publishCategoryValue === POSITION_TYPE_INTERNAL_VALUE;
    }
    // For external positions - show all external positions, plus internal-only to Monday employees
    if (publishCategoryValue === POSITION_TYPE_INTERNAL_VALUE) {
        return isMondayEmployee; // Show internal-only positions only to Monday employees
    }
    // Show all other positions (external, "Both", and any other values) to everyone
    return true;
};
const filterByPositionType = (allPositionsData, positionsType, isMondayEmployee = false)=>{
    return allPositionsData.filter((position)=>isPositionRelevantToType(position, positionsType, isMondayEmployee));
};
const getPositions = function() {
    var _ref = _async_to_generator(function*(query, req = null, res = null) {
        try {
            const { positionsType: rawPositionsType } = query;
            const positionsType = rawPositionsType || 'external';
            let isMondayEmployee = false;
            // Read Monday employee status from cookies if req/res are available
            if (req && res) {
                try {
                    const { getCookie } = require("cookies-next");
                    const lastLoginAccount = getCookie(LAST_ACCOUNT_SLUG, {
                        req,
                        res
                    });
                    isMondayEmployee = lastLoginAccount === 'monday';
                } catch (error) {
                // Cookie reading failed, isMondayEmployee remains false
                }
            }
            const allPositionsData = yield getDataFromComeet();
            if (!allPositionsData || allPositionsData.ERROR) {
                throw new InternalServerError("error fetching positions data");
            }
            return filterByPositionType(allPositionsData, positionsType, isMondayEmployee);
        } catch (e) {
            Sentry.captureException(e);
            Sentry.captureMessage("Failed to fetch career positions from Comeet");
            return [];
        }
    });
    return function getPositions(query) {
        return _ref.apply(this, arguments);
    };
}();
export default [
    {
        propsPropertyName: "positions",
        shouldFetch: ()=>false,
        fetch: function() {
            var _ref = _async_to_generator(function*({ query, req, res }) {
                return yield getPositions(query, req, res);
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }
];
